export {};

const sliderConfig = {
    arrows: true,
    centerPadding: 0,
    dots: false,
    infinite: false,
    adaptiveHeight: true,
    prevArrow: NLMK.generateSlickArrow('left', 'prev'),
    nextArrow: NLMK.generateSlickArrow('right', 'next'),
    slidesToShow: 3,
    lazyLoad: 'progressive',
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};

$(init);

NLMK.initMediaSliders = init;

function init() {
    $('.media-slider').each(eachSlider);
}

function eachSlider(sliderIndex, SliderElement) {
    const $slider = $(SliderElement);
    let $slides = null;

    if ($slider.data('media-slider-init')) {
        return true;
    }

    $slider.data('media-slider-init', true);

    const $list = $slider.find('.media-slider__list');
    $slides = $list.find('.media-slide');
    const $filter = $($list.data('filter'));
    let SlickInstance;
    let slideMouseEnterZIndex = 0;

    $filter.on('click', '.filter__link', onFilterLinkClick);

    initSlick($list);

    function onSlickInit(ev, Instance) {
        SlickInstance = Instance;
        // const timer = setTimeout(() => {
        //     SlickInstance.setPosition();
        // }, 1000);
        const images = SlickInstance.$list.find('img');
        images.each((i, el) => {
            el.onload = () => {
                setTimeout(() => {
                    SlickInstance.setPosition();
                }, 500);
            };
        });
    }

    function onFilterLinkClick(evt) {
        const Link = evt.currentTarget;
        const classModifier = Link.hash.replace('#', '');

        initFilteredSlides($list, classModifier);
    }

    function initSlick($list) {
        $list
            .on('init', onSlickInit)
            .slick(sliderConfig)
            .on(NLMK.MOUSEENTER_EVENT, '.slick-slide', (evt) => {
                $(evt.currentTarget)
                    .addClass('hover')
                    .css({ zIndex: ++slideMouseEnterZIndex })
                    .find('.media-slide')
                    .addClass('hover');
            })
            .on(NLMK.MOUSELEAVE_EVENT, '.slick-slide', (evt) => {
                const $slide = $(evt.currentTarget);

                $slide.find('.media-slide').removeClass('hover');

                setTimeout(() => {
                    $slide.css({ zIndex: '' }).removeClass('hover');
                }, NLMK.TRANSITION_DURATION);
            });
    }

    function initFilteredSlides($slider, filter) {
        let filteredSlides = [];
        $slider.slick('unslick');
        $slider.empty();

        if (!filter) {
            filteredSlides = $slides;
        } else {
            for (let index = 0; index < $slides.length; index++) {
                const filterType = $($slides[index]).data('type');

                if (filterType == filter) {
                    filteredSlides.push($slides[index]);
                }
            }
        }

        for (let index = 0; index < filteredSlides.length; index++) {
            $slider.append(filteredSlides[index]);
        }

        initSlick($slider);
    }
}



// WEBPACK FOOTER //
// ./js/main/module/sliders/media.js